import { useCallback, useState } from 'react';
import { useSnackbar } from 'notistack';
import { openDataAccessConsole } from '../utils/dataAccessSso';

/**
 * opens the Data Access Console through the SSO handshake, tracking only whether this
 * caller's own request is in flight.
 * local state rather than a redux slice: there is nothing to share, and the navbar button
 * and the my-workspace page each want their own spinner rather than a shared one.
 * @author Akhil E M
 * @createdAt 27-08-2026
 * @updates 27-08-2026(Akhil EM),
 * @type hook
 * @returns {{loading: boolean, open: function}}
 */
export default function useDataAccessConsole() {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const open = useCallback(async () => {
    //GUARDS AGAINST A DOUBLE CLICK OPENING TWO TABS
    if (loading) return;
    setLoading(true);
    try {
      await openDataAccessConsole((message) => enqueueSnackbar(message, { variant: 'error' }));
    } finally {
      setLoading(false);
    }
  }, [loading, enqueueSnackbar]);

  return { loading, open };
}
